// src/helpers/fractionSimplification.ts
var FractionSimplifier = class {
  constructor() {
    this.gcdMemo = {};
  }
  gcd(a, b) {
    const key = `${a},${b}`;
    if (this.gcdMemo[key])
      return this.gcdMemo[key];
    if (b === 0)
      return a;
    return this.gcd(b, a % b);
  }
  simplify(numerator, denominator) {
    const gcd = this.gcd(numerator, denominator);
    return [numerator / gcd, denominator / gcd];
  }
  stringify(numerator, denominator) {
    const integer = Math.floor(numerator / denominator);
    numerator = numerator % denominator;
    if (numerator === 0)
      return `${integer}`;
    if (integer === 0)
      return `${numerator}/${denominator}`;
    return `${integer} ${numerator}/${denominator}`;
  }
  simplifyFraction(numerator, denominator) {
    const [simplifiedNumerator, simplifiedDenominator] = this.simplify(
      numerator,
      denominator
    );
    const stringified = this.stringify(
      simplifiedNumerator,
      simplifiedDenominator
    );
    return stringified;
  }
};
var fractionSimplifier = new FractionSimplifier();
var simplifyFraction = fractionSimplifier.simplifyFraction.bind(fractionSimplifier);

export { simplifyFraction };
